export const getMappedPlatformAccounts = (accountData) => {
  return accountData.map((account) => ({
    id: account.id,
    platform: account.platform,
    account_id: account.account_id,
    industry_id: account.industry_id,
    name: `${account.account_name} - ${account.id}`,
  }));
};
